import React, {useState, useRef, useEffect} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t, getLanguage} from 'react-switch-lang';
import {
  getAllMetodologies,
  createMetodology,
  deleteMetodology,
  updateMetodology,
} from '../../../services/metodologiesService';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from './plus.png';
import './Metodologies.scss';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
import Swal from "sweetalert2";
const Metodology = () => {
  const [metodology, setMetodology] = useState([]);
  const [query, setQuery] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllMetodologies();
        setMetodology(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      title: t('metodologies.name'),
      editable: true,
      placeholder: t('metodologies.placeholder.name'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('metodologies.nameEn'),
      editable: true,
      placeholder: t('metodologies.placeholder.nameEn'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.id = editingRecord.id;
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await updateMetodology(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('metodologies.message.updateSuccess', {
            entity: t('metodologies.metodology'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.metodologyExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.metodologyExists')],
          },
        ]);
      }
    }
  };
  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await createMetodology(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('metodologies.message.addSuccess', {
            entity: t('metodologies.metodology'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.metodologyExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.metodologyExists')],
          },
        ]);
      }
    }
  };
  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteMetodology'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
        confirmButtonText: t('common.delete').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            const response = await deleteMetodology(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('metodologies.message.deleteSuccess', {
                  entity: t('metodologies.metodology'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: `${t('message.errorDeleteMethodology')}`,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        },
      });
    });
  };
  const addButton = useRef();
  return (
    <div className="users administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search-field">
          <SearchBox
            placeholder={t('metodologies.placeholder.search')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('metodologies.add')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/methodologies"
        columns={columns}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        query={query}
        queryParamName="name.contains"
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};

export default Metodology;
